import useHomeVenueDetail from "./useHomeVenueDetail";
import useHomeVenuePrice from "./useHomeVenuePrice";

export default function useHome() {
  const { venue } = useHomeVenueDetail();

  const { priceList } = useHomeVenuePrice();

  return { venue, priceList };
}
